import React from "react";
import { ParticlesDemo } from "./Particles";

export const Meet = () => {
  return (
    <div className="meet meet_B pb-5" style={{ overflow: "hidden" }}>
      <div className="container">
        <div className="row align-items-center centerB">
          <div className="col-xl-6">
            <button className="btn-gradient mb-4 ">
              <div
                className="d-flex align-items-center"
                style={{ gap: "3px", fontWeight: "600" }}
              >
                <span>Meet</span>
                <img
                  style={{ width: "30px", verticalAlign: "middle" }}
                  src="/images/usb-logo.png"
                  alt=""
                />
              </div>

            </button>
            <div className="">
              <h2 className="usb-hero-heading">
                A decentralized, yield-bearing stablecoin redefining finance
              </h2>
              {/* <p className="usb-hero-desc">
                A groundbreaking stablecoin designed to generate yields while
                decentralizing finance. It transforms the way we think about
                financial systems, offering innovative solutions for users
                seeking stability and growth.
              </p> */}
            </div>
          </div>
          <div className="col-xl-6" data-aos="fade-up" data-aos-delay="400">
            <div className="video-wrapper">
            <video autoPlay loop muted playsInline className="video">
              <source src="/images/scubes.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            </div>
          </div>
        </div>
        <div className="row my-4 usb_box">
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <div className="cards block white">
              <img alt="" src="/images/icon1.png" />
              <h4>Yield-bearing</h4>
              <p>Earn interest just by holding USB.</p>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <div className="cards block grey">
              <img alt="" src="/images/icon2.png" />
              <h4>Backed by cryptoassets</h4>
              <p>Collateralized by a basket of digital currencies.</p>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <div className="cards block white">
              <img alt="" src="/images/icon3.png" />
              <h4>Independent from banks</h4>
              <p>
                Built in an unparalleled way eliminating reliance on traditional
                financial institutions.
              </p>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <div className="cards block grey">
              <img alt="" src="/images/icon4.png" />
              <h4>Decentralized</h4>
              <p>Decentralization, right at the core of our design.</p>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <div className="cards block white">
              <img alt="" src="/images/icon5.png" />
              <h4>Transparent</h4>
              <p>Real-time data, monthly audits and proof-of-reserve reports.</p>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <div className="cards block grey">
              <img alt="" src="/images/icon6.png" />
              <h4>A unique money transfer platform</h4>
              <p>Super fast and cost-effective cross border transactions.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
